import { render, staticRenderFns } from "./DashboardRevenue.vue?vue&type=template&id=d79d62ce&scoped=true"
import script from "./DashboardRevenue.vue?vue&type=script&lang=js"
export * from "./DashboardRevenue.vue?vue&type=script&lang=js"
import style0 from "./DashboardRevenue.vue?vue&type=style&index=0&id=d79d62ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79d62ce",
  null
  
)

export default component.exports